import React from "react";
import styled from "styled-components";
import { ProductIcon, Tooltip } from "@components";
import { ModuleSetting } from "@models";
import {
	groupModuleSettingsByProduct,
	summarizeMSs,
} from "@components/users/util";
import { colors } from "@theme/theming";

type Props = {
	moduleSettings: ModuleSetting[];
};

export default function UserProductSummary(props: Props) {
	const { moduleSettings } = props;
	const groupedModuleSettings = groupModuleSettingsByProduct(moduleSettings);

	const tooltip = (
		<>
			{groupedModuleSettings.map(({ id, moduleSettings, productName }) => (
				<div key={id}>{`${productName}: ${summarizeMSs(moduleSettings)}`}</div>
			))}
		</>
	);

	return (
		<Tooltip
			id="product-summary-tooltip"
			data-testid="product-summary-tooltip"
			tooltip={tooltip}
		>
			<span>
				{groupedModuleSettings.map((b) => (
					<Icon
						key={b.id}
						data-testid={"product-icon-" + b.id}
						className={b.moduleSettings?.length > 0 ? "active" : "inactive"}
					>
						<ProductIcon productId={b.id} />
					</Icon>
				))}
			</span>
		</Tooltip>
	);
}

const Icon = styled.span`
	&.active {
		color: ${colors.primary.p200};
	}
	&.inactive {
		color: ${colors.gray.g300};
	}
	margin: 2px;
`;
